export class DiagnosisService {

  public getDiagnoses(): DiagnosisCodeData[] {
    return mockDiagnosisCodes;
  }
  public getProcedureCodes(): ProcedureCodeData[] {
    return mockProcedureCodes;
  }
}

export interface CodeData {
  id: number;
  action: string;
  code: string;
}

export interface DiagnosisCodeData extends CodeData {
  pdx: string[],
  drgModifier: string[],
  description: string,
  poa: string,
  quality: string[],
  risk: string[],
}

export interface ProcedureCodeData extends CodeData {
  slot: string[];
  impact: string[];
  description: string;
}

const mockDiagnosisCodes = [
  { id: 1, action: '', pdx: ['Pdx'], drgModifier: ['CC'], code: 'C80.0', description: 'Disseminated malignant neoplasm, unspecified', poa: 'Y - Yes', quality: ['HAC', 'PSI'], risk: ['HCC','ELIX'] },
  { id: 2, action: '', pdx: [], drgModifier: [], code: 'D59.12', description: 'Malignant (primary) neoplasm, unspecified', poa: 'Y - Yes', quality: ['PSI'], risk: [] },
  { id: 3, action: '', pdx: [], drgModifier: [], code: 'Q34.65', description: 'Congenital hypoplasia and dysplasia of lung', poa: 'Y - Yes', quality: [], risk: [] },
  { id: 4, action: '', pdx: [], drgModifier: ['CC'], code: 'J30.1', description: 'Allergic rhinitis due to pollen', poa: 'Y - Yes', quality: [], risk: [] },
  { id: 5, action: '', pdx: [], drgModifier: [], code: 'H00.014', description: 'Hordeolum externum left upper eyelid', poa: 'Y - Yes', quality: [], risk: [] },
  { id: 6, action: '', pdx: [], drgModifier: [], code: 'A41.89', description: 'Other specified sepsis', poa: 'N - No', quality: ['HAC'], risk: ['ELIX'] },
  { id: 7, action: '', pdx: [], drgModifier: [], code: 'A41.89', description: 'Other specified sepsis', poa: 'Y - Yes', quality: [], risk: [] },
  { id: 8, action: '', pdx: [], drgModifier: ['MCC'], code: 'M79.672', description: 'Pain in left foot', poa: 'Y - Yes', quality: [], risk: ['HCC'] },
  { id: 9, action: '', pdx: [], drgModifier: [], code: '', description: '', poa: '', quality: [], risk: [] }
];

const mockProcedureCodes = [
  { id: 1, action: '', slot: [], impact: ['OR'], code: '0LQ93ZZ', description: 'Repair Right Trunk Tendon, Percutaneous Approach'},
  { id: 2, action: '', slot: [], impact: [], code: 'F0796EZ', description: 'Therapeutic exercise treatment of respiratory system - upper back / upper extremity using orthosis'},
  { id: 3, action: '', slot: [], impact: ['OR'], code: '0LQ93ZZ', description: 'Repair Right Trunk Tendon, Percutaneous Approach'},
  { id: 4, action: '', slot: [], impact: [], code: 'F0796EZ', description: 'Therapeutic exercise treatment of respiratory system - upper back / upper extremity using orthosis'},
  { id: 5, action: '', slot: [], impact: [], code: '', description: ''}
]


